<template>
  <div>
    <v-select
        :options="paginated"
        v-model="token" label="name"
        @option:selected="updateToken"
        @select="updateToken"
        :filterable="false"
        :clearable="false"
        @open="onOpen"
        @close="onClose"
        @search="(query) => {search = query}"
        class="w-100 border-0 "
    >

      <template v-slot:selected-option="option">
        <img :src="option.logoURI" width="35" style="margin-right:5px; max-width:35px; max-height:35px">
        <strong>{{ option.symbol }}</strong>
      </template>

      <template v-slot:option="option">

        <img :src="option.logoURI" loading="lazy" style="margin-right:5px; max-width:35px; max-height:35px">
        <strong>{{ option.symbol }}</strong> <small class="text-muted">{{ option.name }}</small>
      </template>

      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader">
          Loading more options...
        </li>
      </template>
    </v-select>
  </div>
</template>

<script>
import {computed, reactive} from 'vue'
import vSelect from 'vue-select'
import {useWallet} from 'solana-wallets-vue'
import {Connection, PublicKey} from "@solana/web3.js";
import axios from "axios"; // if we want to sort tokens by eg volume, trending, etc
import Fuse from 'fuse.js'

export default {
  name: "TokenSelector",
  components: {'v-select': vSelect},
  props: {
    tokens: {
      type: Array,
      required: true,
    },
    'selected': Object,
  },
  setup(props, {emit}) {
    const token = computed({
      get: () => props.selected,
      set: (value) => emit('update:selected', value)
    })

    return {
      token,
    }
  },
  data() {
    return {
      search: '',
      limit: 25,
      fromToken: null,
      observer: null,
    }
  },
  computed: {
    wallet() {
      return reactive(useWallet())
    },
    filtered() {
      // return this.tokens.filter((token) =>  ( token.symbol.toLowerCase().includes(this.search.toLowerCase())) ) // do we want to search on name? Endless 'Solana Cows' etc here tho
      const fuse = new Fuse(this.tokens, {
        keys: [{
          name: 'symbol',
          weight: 0.3,
        },
          {
            name: 'name',
            weight: 0.7,
          }
        ],
        shouldSort: true,
      })
      return this.search.length
          ? fuse.search(this.search).map(({item}) => item)
          : this.tokens
    },
    paginated() {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length
    },
  },
  mounted() {
    /**
     * You could do this directly in data(), but since these docs
     * are server side rendered, IntersectionObserver doesn't exist
     * in that environment, so we need to do it in mounted() instead.
     */
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  methods: {
    updateToken(token) {
      this.$emit('update', token)
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
  },
}
</script>
<style>
.vs__dropdown-toggle {
  border-width: 0px;
}
.vs__dropdown-menu {
  min-width:400px;
  min-height:500px;
  margin-top:20px;
  scrollbar-width:thin;
  scrollbar-color: #adacac;
}
</style>
